export * from './adressenController.service';
import { AdressenControllerService } from './adressenController.service';
export * from './customFieldController.service';
import { CustomFieldControllerService } from './customFieldController.service';
export * from './emaController.service';
import { EmaControllerService } from './emaController.service';
export * from './kontaktController.service';
import { KontaktControllerService } from './kontaktController.service';
export * from './kundenController.service';
import { KundenControllerService } from './kundenController.service';
export * from './leitstellenController.service';
import { LeitstellenControllerService } from './leitstellenController.service';
export * from './lieferantenController.service';
import { LieferantenControllerService } from './lieferantenController.service';
export * from './objektIdentController.service';
import { ObjektIdentControllerService } from './objektIdentController.service';
export * from './userController.service';
import { UserControllerService } from './userController.service';
export * from './userLevelController.service';
import { UserLevelControllerService } from './userLevelController.service';
export * from './videoController.service';
import { VideoControllerService } from './videoController.service';
export * from './wartungController.service';
import { WartungControllerService } from './wartungController.service';
export const APIS = [AdressenControllerService, CustomFieldControllerService, EmaControllerService, KontaktControllerService, KundenControllerService, LeitstellenControllerService, LieferantenControllerService, ObjektIdentControllerService, UserControllerService, UserLevelControllerService, VideoControllerService, WartungControllerService];
